<template>
  <v-card class="pa-6">
    <BaseDataTable
      :headers="headers"
      :items="info"
      :items-per-page="8"
      :loading="loading"
      :search="search"
      :paginate="true"
      :footer-props="{ itemsPerPageText: 'Linhas por página' }"
    >
      <template v-slot:top>
        <v-row class="ma-0 pa-0">
          <v-col cols="12" md="8" lg="8" class="pa-0">
          </v-col>
          <v-col cols="12" md="4" lg="4" class="pa-0">
            <v-text-field
              class="ma-0 pa-0"
              v-model="search"
              :placeholder="'Buscar por schema'"
              prepend-inner-icon="mdi-magnify"
              outlined
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <div class="d-flex w-100">
          <v-switch
            v-can:permission="'bloqueio-entrada-nf#update'"
            color="primary"
            v-model="item.status"
            @click.native.stop="changeBlock(item)"
          ></v-switch>
          <v-icon :color="item.status ? 'primary' : 'default'" class="ml-2">
            {{
              item.status ? "mdi-lock-outline" : "mdi-lock-open-variant-outline"
            }}
          </v-icon>
        </div>
      </template>
      <template v-slot:[`item.logs`]="{ item }">
        <v-btn color="#4ebf53" icon @click="openModal(item)">
          <v-icon>mdi-file-document</v-icon>
        </v-btn>
      </template>
    </BaseDataTable>
    <ModalLogs :dialog="dialog" :schema="schema" @close="dialog = false" />
  </v-card>
</template>

<script>
import BaseDataTable from "@/components/BaseDataTable";
import bloqueios from "@/services/http/rpa/Bloqueios.js";
import ModalLogs from "./ModalLogs.vue";
export default {
  components: {
    ModalLogs,
    BaseDataTable
  },
  data() {
    return {
      dialog: false,
      search: "",
      schema: "",
      loading: false,
      info: [],
      filterMenu: false,
      headers: [
        {
          text: "Schema",
          value: "schema",
          align: "center",
          sortable: true,
          filterable: true,
        },
        {
          text: "Bloqueio",
          value: "status",
        },
        {
          text: "Logs",
          value: "logs",
          align: "center",
        },
      ],
    };
  },

  methods: {
    async fetchBlocks() {
      try {
        this.loading = true;
        let { data } = await bloqueios().show({ per_page: 8 });
        this.info = data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    openModal(item) {
      this.schema = item.schema;
      this.dialog = true;
    },

    async changeBlock(item) {
      let negation = !item.status;
      item.status = negation;

      try {
        let text = item.status === false ? "bloquear" : "desbloquear";
        await this.$swal({
          title: `${text} nota`,
          text: `Deseja ${text} esta nota?`,
          icon: "question",
          showDenyButton: true,
          confirmButtonText: `Sim! ${text}`,
          denyButtonText: "Não, Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await bloqueios().store({ schema: item.schema });
            item.status = !negation;
            return;
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
  },

  created() {
    this.fetchBlocks();
  },
};
</script>

<style scoped>
/deep/.v-input__slot {
  background-color: #eef2f7 !important;
  margin: 0 !important;
}
</style>
